import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";

const slidersClass = `slider-text-slider`;
const blockClass = `slider-text-block`;
const pagination = `slider-text-pagination`;

const TextSlider = {};

TextSlider.blockName = 'text-slider';

TextSlider.init = () => { 
    AcfHelper.handleInit(TextSlider.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            slidesPerView: 1,
            loop: true,
        });
    });
};

TextSlider.init();

export default TextSlider;
